<template>
  <path
    d="M21 3.00024H3C1.89 3.00024 1 3.89024 1 5.00024V19.0002C1 20.1102 1.89 21.0002 3 21.0002H21C22.11 21.0002 23 20.1102 23 19.0002V5.00024C23 3.89024 22.11 3.00024 21 3.00024ZM20 19.0202H4C3.45 19.0202 3 18.5702 3 18.0202V5.98024C3 5.43024 3.45 4.98024 4 4.98024H20C20.55 4.98024 21 5.43024 21 5.98024V18.0202C21 18.5702 20.55 19.0202 20 19.0202ZM10 12.0002H8L11.65 8.35024C11.85 8.15024 12.16 8.15024 12.36 8.35024L16 12.0002H14V16.0002H10V12.0002Z"
  />
</template>
